import { render } from "./StatisticWidget.vue?vue&type=template&id=28d029ba"
import script from "./StatisticWidget.vue?vue&type=script&lang=js"
export * from "./StatisticWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__